import Home from './Home';
import Ranking from './Ranking';
import Snapshot from './Snapshot';
import Snapshots from './Snapshots';
import MyProfile from './MyProfile';
import MyRankings from './MyRankings';
import RankingInvite from './RankingInvite';
import RankingDetails from './RankingDetails';
import Scores from './Scores';
import Login from './Login';
import Signup from './Signup';
import Matches from './Matches';
import Fixture from './Fixture';
import FixtureEmbed from './Fixture';
import Rules from './Rules';
import TermsAndConditions from './TermsAndConditions';

const Pages = {
  Home,
  Snapshot,
  Ranking,
  RankingDetails,
  MyProfile,
  MyRankings,
  RankingInvite,
  Snapshots,
  Scores,
  Login,
  Signup,
  Matches,
  Fixture,
  FixtureEmbed,
  Rules,
  TermsAndConditions,
};

export default Pages;
